import { useState } from "react";
import IndividualLoanRepayment from "./Components/IndividualLoanRepayment";
import GroupLoanRepayment from "./Components/GroupLoanRepayment";

const TABS = [
  { key: "IndividualLoanRepayment", label: "Individual Loan Repayment", icon: "mdi-account-outline" },
  { key: "GroupLoanRepayment",      label: "Group Loan Repayment",       icon: "mdi-account-group-outline" },
];

function LoanRepayments() {
  const [key, setKey] = useState("IndividualLoanRepayment");

  return (
    <div>
      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Loan Repayments</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>Loan</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Loan Repayments</span>
        </div>
      </div>

      {/* ── Tab Bar ── */}
      <div style={{ display: "flex", borderBottom: "2px solid #E2E8F0", marginBottom: 24, gap: 0 }}>
        {TABS.map((tab) => {
          const isActive = key === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setKey(tab.key)}
              style={{
                padding: "10px 22px", fontSize: 13,
                fontWeight: isActive ? 700 : 500,
                color: isActive ? "#fff" : "#718096",
                background: isActive ? "#1B5E20" : "#fff",
                border: "none",
                borderBottom: isActive ? "2px solid #1B5E20" : "2px solid transparent",
                borderRadius: "8px 8px 0 0",
                cursor: "pointer", transition: "all 0.18s",
                outline: "none", marginBottom: -2, letterSpacing: 0.1,
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Tab Content ── */}
      {key === "IndividualLoanRepayment" && <IndividualLoanRepayment />}
      {key === "GroupLoanRepayment"      && <GroupLoanRepayment />}
    </div>
  );
}

export default LoanRepayments;
